import styled from "styled-components";

export const TOBPMainWrapper = styled.div`
  width: 100%;
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  flex-flow: column;
  gap: 1em;
  min-height: 60vh;

  .flexDiv {
    display: flex;
    flex-flow: row wrap;
    justify-content: space-between;
    align-items: center;
    gap: 10px;
    margin-bottom: 2em;
  }

  p.selected {
    span {
      font-weight: 600;
      color: var(--accent);
    }
  }

  .rackSearch {
    width: 100%;
    display: flex;
    flex-flow: column;
    gap: 2em;
    align-items: flex-start;
    justify-content: space-evenly;
  }

  .submitBtn {
    width: 100%;

    svg {
      font-size: 16px;
    }
  }
`;

export const CurrBinNo = styled.p`
  font-weight: 400;
  font-size: 16px;
  color: var(--dark-light);

  span {
    color: var(--accent);
    font-weight: 600;
    font-size: 20px;
  }
`;
